import { ChangeDetectionStrategy, Component, booleanAttribute, input } from '@angular/core';

/**
 * Highlighted read-only total row (e.g. "Gesamtkosten je Modul  1.234,56 €"),
 * matching the Kenergy design system's computed-value convention.
 *
 * @example <app-computed-total label="Gesamtkosten je Modul" [value]="totalCosts() + ' €'" />
 */
@Component({
  selector: 'app-computed-total',
  standalone: true,
  template: `
    <div class="flex items-center justify-between rounded-lg bg-muted px-4 py-3.5">
      <span
        class="text-xs text-foreground"
        [class.font-bold]="emphasized()"
        >{{ label() }}</span
      >
      <span
        class="font-mono text-foreground"
        [class]="emphasized() ? 'text-lg' : 'text-sm'"
        >{{ value() }}</span
      >
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComputedTotal {
  label = input.required<string>();
  value = input.required<string>();
  /** Larger value text for the single "grand total" row of a step */
  emphasized = input(true, { transform: booleanAttribute });
}
